import { Navigate } from "react-router-dom";
import useAuth from "./useAuth";

const RedirectToHomeIfLoggedIn = ({ children }: { children: JSX.Element }) => {
  const authToken = useAuth();

  return authToken ? <Navigate to="/" /> : children;
};

export default RedirectToHomeIfLoggedIn;
